import { useParams } from 'react-router-dom';
import cn from 'bem-cn';

import { Stack } from '../../../components/UI';
import { NoPromptsBanner } from '../../../components/NoPromptsBanner';
import { Feed } from '../../../components/Feed';
import { usePromptFeedColumns } from '../../HomePage/HomePage.hooks';
import { useGetUserPromptsQuery } from '../../../store';

import './ProfilePrompts.scss';

const b = cn('profile-prompts');

export const ProfilePrompts = () => {
    const { loginOrPublicId } = useParams<{ loginOrPublicId: string }>();

    const {
        data: userPrompts = [],
        isFetching,
        isSuccess,
    } = useGetUserPromptsQuery({ loginOrPublicId: loginOrPublicId || '' }, { skip: !loginOrPublicId });

    const columns = usePromptFeedColumns();
    const correctedColumns = Math.min(columns, Math.max(2, userPrompts.length));

    const getSectionSize = () => {
        if (userPrompts.length < 3) {
            return 'small';
        }

        if (userPrompts.length === 3) {
            return 'medium';
        }

        return 'large';
    };

    return (
        <Stack spacing={24} className={b({ size: getSectionSize() })}>
            <div className={b('header')}>
                <h2>Промпты</h2>
            </div>
            <div className={b('content')}>
                {isSuccess && userPrompts.length === 0 ? (
                    <NoPromptsBanner />
                ) : (
                    <Feed prompts={userPrompts} columns={correctedColumns} isLoading={isFetching} />
                )}
            </div>
        </Stack>
    );
};
